export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  heroTitle: string;
  heroSubtitle: string;
}

export const categories: Category[] = [
  {
    slug: "wanghong-dagua",
    name: "网红大瓜",
    description: "追踪网红圈最新动态，不放过任何一个大瓜",
    icon: "ri-user-star-line",
    articleCount: 1283,
    heroTitle: "网红大瓜",
    heroSubtitle: "追踪流量名人，一个瓜都不放过",
  },
  {
    slug: "heiliao-baoliao",
    name: "黑料爆料",
    description: "独家黑料第一手爆料，还原事件真相",
    icon: "ri-spy-line",
    articleCount: 967,
    heroTitle: "黑料爆料",
    heroSubtitle: "独家内幕，深度挖掘，还原真实",
  },
  {
    slug: "meiri-dasai",
    name: "每日大赛",
    description: "娱乐圈每日大事记，吃瓜必备指南",
    icon: "ri-calendar-event-line",
    articleCount: 2156,
    heroTitle: "每日大赛",
    heroSubtitle: "娱乐圈一日不落，大事小情全掌握",
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find(c => c.slug === slug);
};